export const updateConversationList = (list, conversationContactResponse) => {

  return list.reduce((list, conversation) => {

    if (conversationContactResponse.conversationUid == conversation.id) {

      var conversationUpdate = {

        ...conversation,
        contactEmail: conversationContactResponse.email

      }
      return [...list, conversationUpdate]

    } else {

      return [...list, conversation]

    }

  }, [])

}


// WEBPACK FOOTER //
// ./src/Components/Conversations/reducer/utils.js